// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"NW-z","inlineTitle":"OW-z","sponsoredAdsWrapper":"PW-z","marketplaceRecosWrapper":"QW-z"};